<template>
    <div>
        <project ref="project" @navigation="navigation"></project>
        <point ref="point" @navigation="navigation"></point>
        <door ref="door" @navigation="navigation"></door>
        <whiteList ref="whiteList" @navigation="navigation"></whiteList>
        <statement ref="statement" @navigation="navigation"></statement>
    </div>
</template>
<!--
    
-->
<script>
    import Project from './project'
    import Point from './point'
    import Door from './door'
    import WhiteList from './whiteList'
    import Statement from './statement'
    export default {
        name: "index",
        components: {
            Project, Point, Door, WhiteList, Statement
        },
        methods: {
            init() {
                this.navigation('project');
                this.$refs.point.closeEvent();
                this.$refs.door.closeEvent();
                this.$refs.whiteList.closeEvent();
                this.$refs.statement.closeEvent();
            },
            navigation(node,...args) {
                this.$refs[node].init(...args);
            }
        }
    }
</script>

<style scoped>

</style>